import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { CheckboxField } from "@/components/fields/checkbox-field";

export interface CdcExplicitConsentFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends React.HTMLAttributes<HTMLDivElement> {
  control: Control<TFieldValues>;
  name: TName;
  text: string;
}
// Renders a CDC explicit consent checkbox field
export function CdcExplicitConsentField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  className,
  text,
  ...htmlProps
}: Readonly<CdcExplicitConsentFieldProps<TFieldValues, TName>>) {
  return (
    <CheckboxField
      control={control}
      name={name}
      label={text}
      className={className}
      {...htmlProps}
    />
  );
}
